var _defs, _ellipse, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStage6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Stage_6:_Customer_Delight",
    "data-name": "Stage 6: Customer Delight",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50.033,
    height: 50.033,
    viewBox: "0 0 50.033 50.033",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1730",
    "data-name": "Rectangle 1730",
    width: 30.746,
    height: 42.655,
    fill: "#fff"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_685",
    "data-name": "Ellipse 685",
    cx: 25.017,
    cy: 25.017,
    rx: 25.017,
    ry: 25.017,
    fill: "#ee3d4b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32061",
    "data-name": "Group 32061",
    transform: "translate(9.709 3.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32060",
    "data-name": "Group 32060",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13525",
    "data-name": "Path 13525",
    d: "M8.723,8.014a.627.627,0,0,0,.826-.941L2.721,2.46a.629.629,0,0,0-.879.059v0A.629.629,0,0,0,1.9,3.4Z",
    transform: "translate(1.166 1.593)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13526",
    "data-name": "Path 13526",
    d: "M8.5,7a.626.626,0,1,0,1.166-.456L6.6.66a.626.626,0,0,0-1.166.456Z",
    transform: "translate(3.719 0.181)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13527",
    "data-name": "Path 13527",
    d: "M.228,22.141A6.125,6.125,0,0,0,0,23.782,5.836,5.836,0,0,0,1.159,27.3,4.881,4.881,0,0,0,3.98,29.135l.9.323-1.8,8.451,1.318.264,1.8-8.451.779.079a4.386,4.386,0,0,0,.974.11,4.571,4.571,0,0,0,2.275-.612,5.467,5.467,0,0,0,2.66-4.356L13.69,8.1,5.674,6.495ZM4.846,25.21a1.3,1.3,0,1,1-1.3-1.306,1.306,1.306,0,0,1,1.3,1.306Zm1.344-3.341a1.3,1.3,0,1,1-1.306,1.3,1.306,1.306,0,0,1,1.306-1.3ZM5.98,20.01a1.3,1.3,0,1,1-1.3-1.306,1.3,1.3,0,0,1,1.3,1.306Z",
    transform: "translate(0 4.482)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13528",
    "data-name": "Path 13528",
    d: "M21.873,25.873a4.881,4.881,0,0,0,2.419-2.317A5.82,5.82,0,0,0,24.8,19.89a5.909,5.909,0,0,0-.527-1.57L16.047,3.938,8.47,6.989l3.869,16.395a5.464,5.464,0,0,0,3.418,3.794,4.606,4.606,0,0,0,2.349.183,4.518,4.518,0,0,0,.938-.284l.75-.221,3.319,7.978,1.246-.507-3.313-7.973ZM19.287,15.752a1.3,1.3,0,1,1-1.045,1.523v0a1.305,1.305,0,0,1,1.045-1.521M18.841,21.7a1.3,1.3,0,1,1,1.045-1.523A1.305,1.305,0,0,1,18.841,21.7m1.455.473a1.3,1.3,0,0,1,2.566-.477v0a1.3,1.3,0,0,1-1.043,1.519h0A1.305,1.305,0,0,1,20.3,22.175",
    transform: "translate(5.846 2.717)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13529",
    "data-name": "Path 13529",
    d: "M9.639,6.766a.7.7,0,0,0,.186.029.625.625,0,0,0,.6-.445L11.568.813l0,0a.628.628,0,0,0-.416-.781l-.012,0a.617.617,0,0,0-.769.417L9.227,5.983l0,0a.629.629,0,0,0,.414.784",
    transform: "translate(6.348 -0.001)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStage6);
export default __webpack_public_path__ + "static/media/stage6.9659fc026172aeb7c856749296a4e17d.svg";
export { ForwardRef as ReactComponent };